import React from "react"
import ReactDOM from "react-dom"
import { Modal } from "./Modal";

interface IProps {
	message: React.ReactNode;
	resolve: (value: any) => void;
	reject: (error: any) => void;
	title?: React.ReactNode;
	onlyAlert: boolean;
}
interface IState {
	hasOpened: boolean;
}

export class Confirm extends React.Component<IProps, IState>
{
	private modal: Modal;
	constructor(props: IProps) {
		super(props);
		this.state = { hasOpened: false };
	}

	componentDidMount() {
		this.show();
	}

	componentWillUnmount() {
		this.close();
	}

	show = () => {
		if (!this.state.hasOpened)
			this.setState({ hasOpened: true });

		this.modal.open();
		this.forceUpdate();
	}

	close() {
		this.modal.close();
	}

	componentDidUpdate(_: IProps, prevState: IState) {
		if (!prevState.hasOpened && this.state.hasOpened) {
			this.modal.open();
		}
	}

	private onConfirm = () => {
		this.modal.close();
		this.props.resolve({});
	}

	private onReject = () => {
		this.modal.close();
		this.props.reject({});
	}

	render() {
		return <Modal
			nofade={true}
			ref={modal => this.modal = modal!}
			header={<h3 className="modal-title text-white">{this.props.title}</h3>}
			onHide={() => this.props.onlyAlert && this.props.reject({})} //todo: fix per confirmMessage, in caso di click fuori dalla dialog non restituisce "false"
			footer={this.props.onlyAlert
				?
				<button type="button" className="btn btn-outline-secondary" data-dismiss="modal" onClick={this.onConfirm}>Ok</button>
				: <>
					<button type="button" className="btn btn-outline-secondary" data-dismiss="modal" onClick={this.onReject}>No</button>
					<button type="button" className="btn btn-primary" onClick={this.onConfirm}>Si</button>
				</>}
		>
			{this.props.message}
		</Modal>;
	}
}

export function messageAlert(text: React.ReactNode, title?: React.ReactNode) {
	return new Promise((resolve: (value: any) => void, reject: (error: any) => void) => {
		var wrapper: any = document.body.appendChild(document.createElement("div"));
		var r = (_: any) => {
			ReactDOM.unmountComponentAtNode(wrapper);
			setTimeout(_ => wrapper.remove(), 500);
			resolve(_);
		};
		ReactDOM.render(<Confirm message={text} resolve={r} reject={r} onlyAlert title={title} />, wrapper);
	});
}
function confirmInternal(text: React.ReactNode, title?: string) {
	return new Promise((resolve: (value: any) => void, reject: (error: any) => void) => {
		var wrapper: any = document.body.appendChild(document.createElement("div"));
		var r = (_: any) => {
			ReactDOM.unmountComponentAtNode(wrapper);
			setTimeout(_ => wrapper.remove(), 500);
			resolve(_);
		};
		var ko = (err: any) => {
			ReactDOM.unmountComponentAtNode(wrapper);
			setTimeout(_ => wrapper.remove(), 500);
			reject(err);
		};
		ReactDOM.render(<Confirm message={text} resolve={r} reject={ko} onlyAlert={false} title={title} />, wrapper);
	});
}

export async function confirmMessage(text: React.ReactNode, title?: string) {
	try {
		await confirmInternal(text, title);
		return true;
	}
	catch (e) {
		return false;
	}
}
